<ng-container *ngIf="show && !!theme">
    <div class="loading-container">
        <div class="loading">
            <ng-container [ngSwitch]="theme">
                <ng-lottie
                    *ngSwitchCase="supportThemes.OMRE"
                    class="loading-image-omre"
                    [options]="options"
                    (animationCreated)="animationCreated($event)"
                ></ng-lottie>
                <ng-lottie
                    *ngSwitchCase="supportThemes.ONEU"
                    class="loading-image-omre"
                    [options]="options"
                    (animationCreated)="animationCreated($event)"
                ></ng-lottie>
                <img
                    *ngSwitchDefault
                    class="loading-image"
                    src="assets/images/loading-image.gif"
                    loading="lazy"
                />
            </ng-container>
            <div class="loading-text">Đang xử lý</div>
        </div>
    </div>
</ng-container>
